const homepage_video = document.getElementById('homepage_video')
const toggle_video_btns = document.querySelectorAll('.js_toggle_mute_homepage_video')

function toggleVideoMute (e) {
  const btn = e.target
  if (homepage_video.muted === true) {
    homepage_video.muted = false
    btn.classList.remove('mute')
  }
  else if (homepage_video.muted === false) {
    homepage_video.muted = true
    btn.classList.add('mute')
  }
}

if (homepage_video) {

  for (var i = 0; i < toggle_video_btns.length; i++) {
    const btn = toggle_video_btns[i]
    btn.addEventListener('click', toggleVideoMute)
  }

}
